/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular.module('app.directives')
.directive('readMoreWords', function($sce) {
  return {
    restrict: 'AE',
    scope: {
      hmtext: '@',
      hmlimit: '@',
      hmfulltext: '@',
      hmMoreText: '@',
      hmLessText: '@',
      hmMoreClass: '@',
      hmLessClass: '@'
    },
    template: `
        <span ng-if="hmtext.length > hmlimit">
          <span class="pull-left" ng-hide="hmfulltext" ng-bind-html="hmtext | limitWord:hmlimit"></span>

          <span ng-hide="hmfulltext">
            &nbsp; ...
            <a class="more-class" href="" ng-click="toggleValue()">
              {{ hmMoreText }}
            </a>
          </span>

          <p ng-show="hmfulltext" ng-bind-html="hmtext"></p>

          <span ng-show="hmfulltext">
            <a class="more-class" href="" ng-click="toggleValue()">{{ hmLessText }}</a>
          </span>

        </span>

        <span ng-if="hmtext.length <= hmlimit" ng-bind-html="hmtext"></span>

        <style type="text/css">
          .more-class {
            color: #4c9bda;
          }
        </style>
    `,
    transclude: true,
    controller: function($scope) {
      $scope.toggleValue = function() {
        $scope.hmfulltext = !$scope.hmfulltext;
      };
    }
  };
})



// WEBPACK FOOTER //
// ./scripts/shared/directives/read-more-words.js